<template>
  <transition name="overlayFade">
    <div class="credits__wrapper" v-if="displayCredits">
      <section class="section">
        <div class="section__wrapper">
          <div class="section__content">
            <router-link :to="{ name: 'view-home' }">
              <img class="credits__hero" src="../assets/BTAB_svg_inverted.svg" alt="Britain Take A Bow">
            </router-link>
          </div>
          <div class="credits__close-icon-wrapper" @click="hideCredits">
            <img class="credits__close-icon" src="../assets/close_icon.svg" alt="Close credits">
          </div>
        </div>
      </section>
      <section class="section">
        <div class="section__wrapper">
          <div class="section__content">
            <div class="credits__top-section">
              <button class="mb-2 mr-2 button inverted" @click="replayVideo">Play again</button>
              <button class="mb-2 mr-3 button" @click="reload">Load a new version</button>
              <div class="mb-2 credits__share-links">
                <span class="credits__share-label mr-3">Share:</span>
                <img 
                  v-sharer
                  data-sharer="twitter"
                  data-title="Britain, Take A Bow!"
                  data-url="https://britaintakeabow.org"
                  class="footer__social-icon mr-3"
                  src="../assets/icon_twitter_dark.svg"
                  alt="Twitter icon"
                >
                <img 
                  v-sharer
                  data-sharer="facebook"
                  data-url="https://britaintakeabow.org"
                  class="footer__social-icon mr-3"
                  src="../assets/icon_facebook_dark.svg"
                  alt="Facebook icon"
                >
                <img 
                  v-sharer
                  data-sharer="linkedin"
                  data-url="https://britaintakeabow.org"
                  class="footer__social-icon mr-3"
                  src="../assets/icon_linkedin_dark.svg"
                  alt="LinkedIn icon"
                >
              </div>
            </div>
            <div class="credits__grid">
              <div class="credits__grid-item credits__grid-item--has-heading">
                <p class="credits__grid-item-heading">By:</p>
                <p>Graeme Crowley</p>
              </div>
              <div class="credits__grid-item credits__grid-item--has-heading">
                <p class="credits__grid-item-heading">Special thanks to:</p>
                <p>Audio production by Paul Crowley</p>
                <p><a class="credits__link" href="https://www.linkedin.com/in/jackhardiker?originalSubdomain=uk">Jack Hardiker</a> and <a class="credits__link" href="https://vimeo.com/259905941">Midnight Oil</a></p>
                <p><a class="credits__link" href="http://simonellisfilms.com">Simon Ellis</a></p>
              </div>
              <div class="credits__grid-item credits__grid-item--has-heading">
                <p class="credits__grid-item-heading"></p>
                <p>Richard Baker</p>
                <p>Horace Keating</p>
                <p><a class="credits__link" href="https://www.tuimedia.com"><img class="credits__link-img" src="../assets/tuiLogo.svg" alt="Tui Media"></a></p>
              </div>
              <div v-if="typoCredit" class="credits__grid-item credits__grid-item--has-heading">
                <p class="credits__grid-item-heading">Typography:</p>
                <p class="credits__grid-item-name">{{ typoCredit.name }}</p>
                <a
                  v-for="(link, index) in getLinksFromCredit(typoCredit.credit)"
                  :key="`credit-${typoCredit.fullName}-${index}`"
                  :href="link.link"
                  class="credits__grid-item-credit credits__link"
                  target="_blank"
                >
                  {{ link.label }}
                </a>
              </div>
            </div>
            <div class="credits__grid">
              <div class="credits__grid-item">
                <p><a class="credits__link" href="http://www.royalspabrass.com">Hugh Rashleigh and Royal Spa Brass</a></p>
                <p><a class="credits__link" href="https://www.etsy.com/uk/shop/mustardandbloodart?ref=l2-shopheader-name">Jonny Nicholds</a>, <a class="credits__link" href="https://en-gb.facebook.com/lucyannesalemusic/">Lucy Anne Sale</a>, <a class="credits__link" href="http://wesfinch.co.uk/">Wes Finch</a> and the Mustard &amp; Blood Orchestra</p>
              </div>
              <div class="credits__grid-item">
                <p ref="creditsBuffer" class="credits__item--is-buffer"><a class="credits__link" href="https://www.instagram.com/lizbuffcrowley/">Liz Crowley</a> for organising and <a class="credits__link" href="https://uk.linkedin.com/in/drew-coleman-7aa38147" >Drew Coleman</a> for recording:</p>
                <p>Adrian Tomaszewski</p>
                <p>Alexandru Kraus</p>
                <p>Barthe Makosso</p>
                <p>Brenna McCann</p>
              </div>
              <div class="credits__grid-item">
                <p class="credits__item--has-buffer" :class="{ 'credits__item--has-buffer-large': bufferLarge }">Elena Fulea</p>
                <p>Elina Baltina</p>
                <p>Greta Lazdovska</p>
                <p>Jeffy Jigy</p>
              </div>
              <div class="credits__grid-item">
                <p class="credits__item--has-buffer credits__item--drop-buffer" :class="{ 'credits__item--has-buffer-large': bufferLarge }">Mateuz Cetnarski</p>
                <p>Musa Nasibu</p>
                <p>Nimeshika Rathnapriyalage</p>
                <p>Vilario Fernandez</p>
              </div>
            </div>
            <p v-if="creditData.length">This viewing featured the work of:</p>
            <div class="credits__grid">
              <div
                v-for="(credit, index) in creditData"
                :key="`credit-${index}`"
                class="credits__grid-item"
              >
                <p class="credits__grid-item-name">{{ credit.fullname }}</p>
                <a
                  v-for="(link, index) in getLinksFromCredit(credit.credit)"
                  :key="`credit-${credit.fullName}-${index}`"
                  :href="link.link"
                  class="credits__grid-item-credit credits__link"
                  target="_blank"
                >
                  {{ link.label }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </transition>
</template>

<script>
import VueSharer from 'vue-sharer';

export default {
  name: 'credits',
  props: {
    creditData: {
      type: Array,
      required: false,
    },
    displayCredits: {
      type: Boolean,
      required: true,
    },
    reload: {
      required: true,
    },
    hideCredits: {
      required: true,
    },
    replayVideo: {
      required: true,
    },
    typoCredit: {
      required: false,
    },
  },
  data() {
    return {
      bufferLarge: false,
    };
  },
  directives: {
    sharer: VueSharer,
  },
  methods: {
    checkBuffer() {
      if (this.$refs.creditsBuffer) {
        this.bufferLarge = this.$refs.creditsBuffer.clientHeight >= 72;
      } else this.bufferLarge = false;
    },
    getLinksFromCredit(credit) {
      if (!credit) return [];
      // Create array of target site credit objects
      // Loop over target site credits and pull out target sites from 'credits'
      // Then handle non-target credits and stick them on the end of the targetSite credits

      const base = credit;
      const credits = base.split(',').map(x => x.trim());

      const targetSites = [
        {
          label: 'Twitter',
          target: 'twitter.com',
        },
        {
          label: 'Facebook',
          target: 'facebook.com',
        },
        {
          label: 'Instagram',
          target: 'instagram.com',
        },
        {
          label: 'LinkedIn',
          target: 'linkedin.com',
        },
      ];

      const processedCredits = [];

      targetSites.forEach((site) => {
        const foundCredit = credits.filter(cred => cred.indexOf(site.target) > -1)[0];
        if (foundCredit) {
          processedCredits.push({
            label: site.label,
            link: this.checkProtocol(foundCredit),
          });
          credits.splice(credits.indexOf(foundCredit), 1);
        }
      });

      const parsedCredits = credits.map((cred) => {
        const baseCredit = cred;
        return {
          label: this.pruneProtocol(baseCredit),
          link: this.checkProtocol(baseCredit),
        };
      });

      return [...processedCredits, ...parsedCredits];
    },
    checkProtocol(str) {
      const url = str;

      const https = url.indexOf('https://') > -1;
      const http = url.indexOf('http://') > -1;

      if (https || http) return url;
      return `http://${url}`;
    },
    pruneProtocol(str) {
      const url = str;

      return url.replace(/^https?\:\/\//i, ''); // eslint-disable-line
    },
  },
  mounted() {
    this.$nextTick(() => this.checkBuffer());
    window.addEventListener('resize', this.checkBuffer);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkBuffer);
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Credits.vue?5ee8bfa8